module.exports = __WEBPACK_EXTERNAL_MODULE_9__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/observable/merge"
// module id = 9
// module chunks = 0